import { useEffect, useState } from "react";

// Plain-language explanation shown before a lock starts; counts down, any console button skips it.
export const LockBrief = ({ title, lines, ms, onDone }) => {
  const [left, setLeft] = useState(Math.ceil(ms / 1000));

  useEffect(() => {
    const started = Date.now();
    const t = setInterval(() => {
      const remaining = Math.max(0, ms - (Date.now() - started));
      setLeft(Math.ceil(remaining / 1000));
      if (remaining === 0) { clearInterval(t); onDone(); }
    }, 200);
    return () => clearInterval(t);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="lock-brief" className="grid gap-4 border border-cyan-400/30 bg-cyan-400/5 p-6">
      <p className="font-mono text-xs uppercase tracking-[0.3em] text-cyan-300">How this works · {title}</p>
      <ol className="grid gap-2.5">
        {lines.map((l, i) => (
          <li key={i} data-testid={`lock-brief-line-${i + 1}`} className="flex gap-3 text-base leading-snug text-slate-100">
            <span className="font-mono text-cyan-300">{i + 1}.</span><span>{l}</span>
          </li>
        ))}
      </ol>
      <div className="flex items-center gap-4">
        <div className="h-1 flex-1 bg-slate-800"><div className="h-full bg-cyan-300 transition-[width] duration-200" style={{ width: `${(left / Math.ceil(ms / 1000)) * 100}%` }} /></div>
        <p data-testid="lock-brief-countdown" className="font-mono text-xs uppercase tracking-widest text-amber-200">Begins in {left} · any console button starts now</p>
      </div>
    </div>
  );
};
